import TeacherListSection from "../components/teacher-list-section";

function TeacherHome() {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Teachers List - Takes remaining height */}
      <div className="h-full">
        <TeacherListSection />
      </div>
    </div>
  );
}

export default TeacherHome;
